import { Component, EventEmitter, Input, Output } from "@angular/core";
import { Action } from "src/app/components/ui/actions/action";
import { ButtonClickAsyncEvent } from "src/app/components/ui/button/button-click-async-event";
import { Lambda } from "src/app/support/lambda";

export interface ActionAsyncEvent {
  execute: (fn: Lambda<Promise<void>>) => Promise<void>;
}

@Component({
  selector: "snt-action",
  template: "",
  providers: [{ provide: Action, useExisting: ActionComponent }],
  standalone: false
})
export class ActionComponent extends Action {
  @Input()
  title: string | undefined;

  @Input()
  icon: string | undefined;

  @Input()
  disabled: boolean | undefined;

  @Input()
  tooltip?: string;

  @Output()
  do: EventEmitter<void> = new EventEmitter<void>();

  @Output()
  doAsync: EventEmitter<ActionAsyncEvent> = new EventEmitter();

  onDoAsync(clickEvent: ButtonClickAsyncEvent) {
    this.doAsync.emit({
      execute: async (fn: Lambda<Promise<void>>) => {
        await clickEvent.execute(fn);
      }
    });
  }
}
